import { render, staticRenderFns } from "./PrezydenckiTemplate.vue?vue&type=template&id=1147f13a&"
import script from "./PrezydenckiTemplate.vue?vue&type=script&lang=js&"
export * from "./PrezydenckiTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports